import React from "react";
import GetInitials from "../GetInitials";
import { isEmpty } from "lodash";
import { faTrashAlt } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import WarningModal from "../WarningModal/WarningModal";
import { useLocation } from "react-router-dom";
import { faCheckCircle, faTimesCircle } from "@fortawesome/pro-light-svg-icons";
import { ssnMasking, usDateFormat } from "../../utils";

const RolloverinApprovalCard = ({ employeeRolloverin, onClickOfCard }) => {
  const location = useLocation();
  return (
    <div className="withDrawalApprovalCard">
      <div
        className="d-flex"
        style={{ justifyContent: "center", alignItems: "center" }}
        onClick={() => {
          onClickOfCard();
        }}
      >
        <div className="employee-icon-wrapper ">
          {!isEmpty(employeeRolloverin.imageURL) ? (
            <img
              alt=""
              src={employeeRolloverin.imageURL}
              style={{ width: "96px", height: "96px", borderRadius: "50%" }}
              className="img-fluid"
            />
          ) : (
            <div style={{ marginTop: "10%", marginLeft: "50px" }}>
              <GetInitials name={employeeRolloverin.employeeName} />
            </div>
          )}
        </div>

        <div style={{ flexDirection: "column", marginBottom: "30px" }}>
          <div
            className="approvalEmployeeName"
            style={{
              fontWeight: "500",
              fontSize: "14px",
              lineHeight: "21px",
              marginLeft: "60px",
            }}
          >
            {employeeRolloverin.employeeName}
          </div>
          <div
            className="ssn"
            style={{ marginLeft: "60px", whiteSpace: "nowrap" }}
          >
            {ssnMasking(employeeRolloverin.ssn)}
          </div>

          {employeeRolloverin.employmentStatus == "Active" ? (
            <div className="employeeStatusActive">
              <FontAwesomeIcon
                icon={faCheckCircle}
                className="employeeStatusActiveIcon"
                style={{ marginLeft: "60px", whiteSpace: "nowrap" }}
              />
              {employeeRolloverin.employmentStatus}
            </div>
          ) : (
            <div className="employeeStatusTerminated">
              <FontAwesomeIcon
                icon={faTimesCircle}
                className="employeeStatusTerminatedIcon"
                style={{ marginLeft: "60px", whiteSpace: "nowrap" }}
              />
              {employeeRolloverin.employmentStatus}
            </div>
          )}
          {/* <div className="employeeStatus">
            <FontAwesomeIcon
              icon={faCheckCircle}
              className="employeeStatusIcon"
              style={{ marginLeft: "60px", whiteSpace: "nowrap" }}
            />
            {employeeRolloverin.employmentStatus}
          </div> */}
        </div>

        {/* vertical Line */}
        <div
          style={{
            height: "70px",
            borderRight: "1px solid #BDBDBD",
            marginBottom: "5px",
            marginLeft: "60px",
          }}
        ></div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "76px",
            whiteSpace: "nowrap",
            fontStyle: "normal",
            fontWeight: "400",
            fontSize: "14px",
            color: "#777777",
            flex: "none",
            order: "0",
            flexGrow: "0",
            marginBottom: "60px",
          }}
        >
          <div
            style={{
              marginRight: "50%",
              whiteSpace: "nowrap",
              marginTop: "60%",
              lineHeight: "30px",
              marginLeft: "120px",
            }}
          >
            {"Plan Name"}
            <div className="planName-ans"> {employeeRolloverin.planName}</div>
          </div>

          <div
            style={{
              whiteSpace: "nowrap",
              marginTop: "60%",
              lineHeight: "30px",
              marginRight: "50%",
              marginLeft: "120px",
            }}
          >
            {"Requested date"}
            <div className="planName-ans" style={{ marginRight: "50%" }}>
              {usDateFormat(employeeRolloverin.requestedDate)}
            </div>
          </div>
        </div>

        {/* 
    <FontAwesomeIcon
       icon={faTrashAlt}
       size="13px"
       color="#FF0000"
       onClick = {()=><WarningModal/>}
    /> */}
      </div>
    </div>
  );
};

export default RolloverinApprovalCard;
